import XLSX from "xlsx";

/**
 * Read ONLY the sheet-name list out of a workbook.
 *
 * `bookSheets: true` makes SheetJS stop after the workbook index — it never
 * builds the cell data (the returned object has no `Sheets` key at all). That
 * matters: real parsing lives on the backend precisely so the browser doesn't
 * chew through large files, and this stays cheap enough to run on every drop
 * just to answer "does this workbook have more than one sheet?".
 *
 * CSV has no sheets — callers should skip this entirely.
 *
 * @param {File} file
 * @returns {Promise<string[]>} sheet names, in workbook order
 */
export const getSheetNames = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Could not read file"));
    reader.onload = () => {
      try {
        const workbook = XLSX.read(new Uint8Array(reader.result), {
          type: "array",
          bookSheets: true,
        });
        resolve(workbook.SheetNames || []);
      } catch (err) {
        reject(err);
      }
    };
    reader.readAsArrayBuffer(file);
  });
